import Icon from '../components/Icon.vue'

Icon.register({"hand-paper":{"width":448,"height":512,"paths":[{"d":"M408.8 128C386.4 127.6 368 146.4 368 168.8V256H360V79.8C360 57.4 341.6 38.6 319.2 39 297.5 39.4 280 57.2 280 79V256H272V40.8C272 18.4 253.6-0.4 231.2 0 209.5 0.4 192 18.2 192 40V256H184V80.8C184 58.4 165.6 39.6 143.2 40 121.5 40.4 104 58.2 104 80V316L72.4 272.5C59.4 254.6 34.3 250.7 16.5 263.6-1.4 276.6-5.3 301.7 7.7 319.5L133.3 492.2A48-48 0 0 1 172.1 512H369.7C391.9 512 411.3 496.7 416.4 475L442.9 362.3A192-192 0 0 1 448 318.4V168C448 146.2 430.5 128.4 408.8 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hand-paper.js
// module id = null
// module chunks = 